export const THIRD_PARTY_LOGIN_PROVIDERS = [
  'google',
  'microsoft'
]
